var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compilation-screen"},[_c('MainGroups',{attrs:{"mode":"noauth","groups-data":_vm.getCollectionGroups}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }